export default {
  state: {
    updateListOnlyKey: 0
  },
  mutations: {
    DOC_SORT_UPDATE_LIST_ONLY(state) {
      state.updateListOnlyKey = new Date().getTime();
    }
  },
  actions: {
    docSortUpdateListOnly({ commit }) {
      commit('DOC_SORT_UPDATE_LIST_ONLY');
    }
  }
}
